import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent {

    public fileToUpload: File = null;

    @Input()
    public btnLabel: string = 'Button';

    @Input()
    public header: string = 'Button';

    @Input()
    public tdrsCreationMode: boolean = false;

    @Input()
    public validateSheet: boolean = true;

    public fileNameDetails = null;

    public errorOverLay = null;

    @Output()
    public handleUpload: EventEmitter<{
        file: Object,
        validateSheet: boolean,
        fileNameDetails: any
    }> = new EventEmitter<{
        file: Object,
        validateSheet: boolean,
        fileNameDetails: any
    }>();

    public myFile = null;

    public startUpload() {

        if (this.isValidFile()) {

            this.handleUpload.emit({
                file: this.fileToUpload,
                validateSheet: this.validateSheet,
                fileNameDetails: this.fileNameDetails
            });
            this.myFile = null;
        } else {

            this.myFile = null;

            this.errorOverLay = {
                message: `Invalid Sheet Name, Sheet Should Be Like <br/><b>TDR (ST)_WFAT-1255_V0.1</b>`,
                success: false
            };
        }
    }

    isValidFile() {

        const fileName = this.fileToUpload.name;

        const isExcel = fileName.indexOf('.xlsx') > 0 && fileName.indexOf('.xls') > 0;

        if (isExcel) {

            let xlsxFileName = fileName.split('.xlsx')[0];

            if (xlsxFileName === fileName) {

                xlsxFileName = fileName.split('.xls')[0];
            }

            if (xlsxFileName) {

                const fileVersion = xlsxFileName.split('_')[2];

                const userStories = xlsxFileName.split('_')[1];

                const env = xlsxFileName.split('_')[0];

                if (userStories) {

                    this.fileNameDetails = {
                        userStories: userStories.split('&'),
                        version: fileVersion
                    };

                    return fileVersion && userStories && env &&
                        fileVersion.startsWith('V') && userStories.startsWith('WF') && env.startsWith('TDR');
                }
            }

            return false;
        }
    }
    fileChange(file) {

        this.fileToUpload = file;
    }

    closeOverLay() {

        this.errorOverLay = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/automation/shared-components/file-uploader/file-uploader.component.ts